/** * Created by rubin on 2020/6/4. */

<template>
  <div class="login-content">
    <div class="content">
      <div class="form sign-in">
        <h2>优比宝盒 登录</h2>
        <label>
          <span>手机号</span>
          <input
            type="text"
            @keyup.enter="doLogin"
            v-model="loginForm.phoneNo"
            ref="phoneNo"
            maxlength="11"
          />
        </label>
        <label>
          <span>密码</span>
          <input
            type="password"
            @keyup.enter="doLogin"
            v-model="loginForm.pin"
          />
        </label>
        <p class="forgot-pass">
          <a href="javascript:" @click="goForget">
            忘记密码？
          </a>
        </p>
        <el-button
          type="warning"
          class="submit"
          :loading="loading"
          @click="doLogin"
          round
          >登 录</el-button
        >
        <el-button type="success" class="quick-login" @click="quickLogin" round
          >快速登录</el-button
        >
      </div>
      <!-- <div class="sub-cont">
        <div class="img">
          <div class="img__text m--up">
            <h2>还未注册？</h2>
            <p>立即注册，享受独有空间！</p>
          </div>
          <div class="img__btn" @click="goRegister">
            <span class="m--up">去 注 册</span>
          </div>
        </div>
      </div> -->
    </div>
    <el-dialog title="" :visible.sync="dialogVisible" width="600px">
      <iframe
        style="width: 100%;height: 500px;"
        src="https://open.weixin.qq.com/connect/qrconnect?appid=wxafc7a84f3b2f83a8&redirect_uri=https%3A%2F%2Fbox.yubbyenglish.top%2FPanResource%2FmemberInfo%2FweixinLogin&response_type=code&scope=snsapi_login&state=3d6be0a4035d839573b04816624a415e&appId=wxafc7a84f3b2f83a8#wechat_redirect"
        frameborder="0"
      ></iframe>
    </el-dialog>
  </div>
</template>

<script>
import panUtil from "../../utils/common";
import userService from "../../api/user";
import { setToken } from "../../utils/cookie";
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      loginForm: {
        phoneNo: "", //13014634005
        pin: "",
        loginType: 1000,
      },
      loading: false,
      dialogVisible: false,
      UrlParam: {
        accessToken: "",
        openId: "",
        nikeName: "",
        sex: "",
        headImgUrl: "",
      },
    };
  },
  mounted() {
    let _this = this;
    this.$refs.phoneNo.focus();
    const params = new URLSearchParams(window.location.href.split("?")[1]);
    this.UrlParam.accessToken = params.get("accessToken");
    this.UrlParam.openId = params.get("openId");
    this.UrlParam.nikeName = params.get("nikeName");
    this.UrlParam.sex = params.get("sex");
    this.UrlParam.headImgUrl = params.get("headImgUrl");

    if (this.UrlParam.openId && this.UrlParam.nikeName) {
      // 已经授权登录成功
      if (this.UrlParam.accessToken != "null") {
        // 已有账号
        setToken(this.UrlParam.accessToken);
        userService.info(
          (res2) => {
            _this.setwechatNickName(res2.data[0].wechatNickName);
            _this.setUserInfo(res2.data[0]);
            _this.$router.push({ name: "Index" });
          },
          (res) => {
            _this.$message.error(res.message);
          }
        );
      } else {
        // 没有账号
        this.goRegister();
      }
    }
  },
  components: {},
  methods: {
    ...mapMutations({
      setUserInfo: "user/setUserInfo",
      setwechatNickName: "user/setwechatNickName",
    }),
    goRegister() {
      this.$router.push({
        name: "Register",
        query: {
          openId: this.UrlParam.openId,
          nikeName: this.UrlParam.nikeName,
          headImgUrl: this.UrlParam.headImgUrl,
        },
      });
    },
    goForget() {
      this.$router.push({ name: "Forget" });
    },
    wxAuthLogin() {},
    doLogin() {
      let _this = this;
      try {
        _this.loading = true;
        userService.login(
          _this.loginForm,
          (res) => {
            setToken(res.data.accessToken);
            userService.info(
              (res2) => {
                _this.setwechatNickName(res2.data[0].wechatNickName);
                _this.setUserInfo(res2.data[0]);
                _this.$router.push({ name: "Index" });
              },
              (res) => {
                _this.$message.error(res.message);
              }
            );
          },
          (res) => {
            _this.$message.error(res.message);
          }
        );
      } finally {
        _this.loading = false;
      }
    },
    quickLogin() {
      this.dialogVisible = true;
    },
  },
  watch: {},
};
</script>

<style scoped>
@keyframes animate-cloud {
  from {
    background-position: 600px 100%;
  }
  to {
    background-position: 0 100%;
  }
}

.login-content {
  display: flex;
  align-items: center;
  position: relative;
  width: 100vw;
  height: 100vh;
  background: url("~@/assets/imgs/background.png") 0 bottom repeat-x
    #049ec4;
  animation: animate-cloud 20s linear infinite;
}
*,
*:before,
*:after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

input {
  border: none;
  outline: none;
  background: none;
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
}

.content {
  overflow: hidden;
  position: absolute;
  left: 50%;
  top: 50%;
  width: 640px;
  height: 550px;
  transform: translateX(-50%) translateY(-50%);
  background: #fff;
}

.form {
  position: relative;
  width: 640px;
  height: 100%;
  transition: -webkit-transform 0.6s ease-in-out;
  transition: transform 0.6s ease-in-out;
  transition: transform 0.6s ease-in-out, -webkit-transform 0.6s ease-in-out;
  padding: 50px 30px 0;
}

.sub-cont {
  overflow: hidden;
  position: absolute;
  left: 640px;
  top: 0;
  width: 900px;
  height: 100%;
  padding-left: 260px;
  background: #fff;
  transition: -webkit-transform 0.6s ease-in-out;
  transition: transform 0.6s ease-in-out;
  transition: transform 0.6s ease-in-out, -webkit-transform 0.6s ease-in-out;
}

button {
  display: block;
  margin: 0 auto;
  width: 260px;
  height: 36px;
  border-radius: 30px;
  color: #fff;
  font-size: 15px;
  cursor: pointer;
}

.img {
  overflow: hidden;
  z-index: 2;
  position: absolute;
  left: 0;
  top: 0;
  width: 260px;
  height: 100%;
  padding-top: 360px;
}

.img:before {
  content: "";
  position: absolute;
  right: 0;
  top: 0;
  width: 900px;
  height: 100%;
  background-image: url(../../assets/imgs/bg.jpg);
  background-size: cover;
  transition: -webkit-transform 0.6s ease-in-out;
  transition: transform 0.6s ease-in-out;
  transition: transform 0.6s ease-in-out, -webkit-transform 0.6s ease-in-out;
}

.img:after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
}

.img__text {
  z-index: 2;
  position: absolute;
  left: 0;
  top: 50px;
  width: 100%;
  padding: 0 20px;
  text-align: center;
  color: #fff;
  transition: -webkit-transform 0.6s ease-in-out;
  transition: transform 0.6s ease-in-out;
  transition: transform 0.6s ease-in-out, -webkit-transform 0.6s ease-in-out;
}

.img__text h2 {
  margin-bottom: 10px;
  font-weight: normal;
}

.img__text p {
  font-size: 14px;
  line-height: 1.5;
}

.img__btn {
  overflow: hidden;
  z-index: 2;
  position: relative;
  width: 100px;
  height: 36px;
  margin: 0 auto;
  background: transparent;
  color: #fff;
  text-transform: uppercase;
  font-size: 15px;
  cursor: pointer;
}

.img__btn:after {
  content: "";
  z-index: 2;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border: 2px solid #fff;
  border-radius: 30px;
}

.img__btn span {
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  transition: -webkit-transform 0.6s;
  transition: transform 0.6s;
  transition: transform 0.6s, -webkit-transform 0.6s;
}

h2 {
  width: 100%;
  font-size: 26px;
  text-align: center;
}

label {
  display: block;
  width: 260px;
  margin: 25px auto 0;
  text-align: center;
}

label span {
  font-size: 12px;
  color: #909399;
  text-transform: uppercase;
}

input {
  display: block;
  width: 100%;
  margin-top: 5px;
  padding-bottom: 5px;
  font-size: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.4);
  text-align: center;
}

.submit {
  margin-top: 40px !important;
}

.forgot-pass {
  margin-top: 15px;
  text-align: center;
  font-size: 12px;
  color: #cfcfcf;
}

.forgot-pass a {
  color: #cfcfcf;
}

.quick-login {
  margin-left: auto !important;
  margin: 20px auto;
}
</style>
